/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepositAddressInfo } from './depositAddressInfo';

/**
 * Fireblocks asset info
 */
export interface FireblocksAssetInfo {
  /**
   * True if it is possible to create new deposit address.
   */
  createNewAvailable: boolean;
  /**
   * External asset name.
   */
  externalAssetName: string;
  /**
   * Full name.
   */
  fullName: string;
  addressInfos: Array<DepositAddressInfo>;
}
